import React from 'react';
import { useParams } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { FormOutlined, ExclamationCircleOutlined, DatabaseOutlined, EyeOutlined, ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Modal, Tooltip, Form, Select, Input, Button } from 'antd';
import {
  intialPaginationState,
  filter,
  unexpectedError,
  showingPageTotalRange,
  formItemLayout,
  tailFormItemLayout,
  PictureCell,
} from '../../common_functions';

const Objects = props => {
  const { section, id } = useParams();
  const [objects, setObjects] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [artists, setArtists] = useState([]);
  const formRef = useRef(null);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  //default filter
  let defaultFilter = {
    object_type: {
      _eq: 'negative',
    },
  };
  // if user view the list from the collection table
  if (section === 'list' && id) {
    defaultFilter = {
      object_type: {
        _eq: 'negative',
      },
      collections: {
        _eq: id,
      },
    };
  }

  useEffect(() => {
    (async () => {
    /**Get artist name*/
    const { data: artistFullName } = await props.getItems('Artist', {
      fields: ['id', 'First_Name', 'last_name'],
      sort: '-id',
      limit: -1,
    });
    setArtists(artistFullName);
    // await getObjectsData(pagination, defaultFilter);
    await onFinishFilter({}, pagination);
  })();
  }, []);
  // const getObjectsData = async (pagination, filters = {}, sorter = '') => {
  //   try {
  //     let checkData = 0;
  //     if (props.roleType != 'admin' && props.prints_negatives_obj.length > 0) {
  //       // filters['id'] = { _in: props.prints_negatives_obj };
  //       filters['collections'] = { _in: props.collections_permissions.view };
  //     }
  //     let condition = props.roleType == 'admin' || (!!props.tabs_permissions.negatives?.view && props.prints_negatives_obj.length > 0);
  //     if (!!condition) {
  //       setLoading(true);
  //       const response = await props.getItems('collection_obj', {
  //         fields: ['object_type,id,title,provenance,acquisition,collections.name,collections.id,negative.obj_name,negative.thumbnail'],
  //         filters: filters,
  //         sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
  //         offset: pagination.pageSize * (pagination.current - 1),
  //         limit: pagination.pageSize,
  //         meta: 'filter_count',
  //       });
  //       checkData = response.data.length;
  //       pagination.total = response.meta.filter_count;
  //       setPagination(pagination);
  //       setObjects(response.data);
  //       setLoading(false);
  //     }
  //     /**Show Popup if collection negative is not created **/
  //     if (section === 'list' && id && !checkData && (!!props.tabs_permissions.negatives?.create || props.roleType == 'admin')) {
  //       Modal.confirm({
  //         icon: <ExclamationCircleOutlined style={{ color: '#1890ff' }} />,
  //         title: 'Information',
  //         content: 'Negative is not created yet',
  //         okText: 'Create now',
  //         cancelText: 'Not now',
  //         centered: true, // show popup at the center of screen
  //         closable: true, // close icon
  //         keyboard: true, // for close on esc key
  //         onOk() {
  //           props.history.push(`/negatives/negative-objects/collection/${id}`);
  //         },
  //         onCancel() {
  //           console.log('Cancel');
  //         },
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     unexpectedError(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const onFinishFilter = async values => {
  //   // Define the fields to search
  //   const fields = [
  //     'negative.obj_name',
  //     'negative.relationship_type.name',
  //     'negative.relationship_type.name',
  //     'negative.work_type_neg.name',
  //     'negative.materials.name',
  //     'work_type.name',
  //     'obj_type.name',
  //     'record_type.name',
  //     'catalog_level.name',
  //     'classification.name',
  //     'image_description.support_table_data.support_table_id.name',
  //     'image_description.geographic_location.geographic_locations_id.park.park',
  //     'image_description.geographic_location.geographic_locations_id.prominent_natural_features',
  //     'image_description.geographic_location.geographic_locations_id.state.state',
  //     'image_description.image_description',
  //     'image_description.specific_sub',
  //     'image_description.depicted_loc',
  //   ];
  //   const keyword = values?.keyword;
  //   const title = values?.title;
  //   const artist = values?.artist;
  //   let filterCriteria = [];
  //   let data = {};

  //   if (keyword) {
  //     const keywords = [...new Set(keyword.replace(/\s+/g, ' ').trim().split(' '))];
  //     console.log('keywords :', keywords);
  //     // Build filter criteria
  //     filterCriteria = keywords.map(word => ({
  //       _or: fields.map(field => {
  //         return field.split('.').reduceRight(
  //           (acc, key) => ({
  //             [key]: acc,
  //           }),
  //           { _icontains: word }
  //         );
  //       }),
  //     }));
  //   }
  //   if (filterCriteria.length) {
  //     title && filterCriteria[0]['_or'].push({ negative: { obj_name: { _icontains: title } } });
  //     artist && filterCriteria[0]['_or'].push({ secondary_artist: { _eq: artist } }, { creator: { _eq: artist } });
  //   } else {
  //     filterCriteria.push({ _or: [] });
  //     title && filterCriteria[0]['_or'].push({ negative: { obj_name: { _icontains: title } } });
  //     artist && filterCriteria[0]['_or'].push({ secondary_artist: { _eq: artist } }, { creator: { _eq: artist } });
  //   }
  //   data = {
  //     _and: [{ _and: filterCriteria, ...defaultFilter }],
  //   };
  //   await getObjectsData(pagination, data);
  // };

  // const getObjectsData = async (pagination, filters = {}, sorter = '') => {
  //   try {
  //     let checkData = 0;
  //     setLoading(true);
  //     filters['collections'] = props?.tabs_permissions?.negatives?.view ? props.collections_permissions.view : [];
  //     filters['object_type'] = { _eq: 'negative' };
  //     const dataObj = {
  //       fields: ['object_type,id,title,provenance,acquisition,collections.name,collections.id,negative.obj_name,negative.thumbnail'],
  //       filters: filters,
  //       sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
  //       offset: pagination.pageSize * (pagination.current - 1),
  //       limit: pagination.pageSize,
  //       meta: 'filter_count',
  //     };
  //     const response = await props.negativeFilterNew(dataObj);
  //     checkData = response.data.length;
  //     pagination.total = response.meta.filter_count;
  //     setPagination(pagination);
  //     setObjects(response.data);
  //     setLoading(false);

  //     /**Show Popup if collection negative is not created **/
  //     if (section === 'list' && id && !checkData && (!!props.tabs_permissions.negatives?.create || props.roleType == 'admin')) {
  //       Modal.confirm({
  //         icon: <ExclamationCircleOutlined style={{ color: '#1890ff' }} />,
  //         title: 'Information',
  //         content: 'Negative is not created yet',
  //         okText: 'Create now',
  //         cancelText: 'Not now',
  //         centered: true, // show popup at the center of screen
  //         closable: true, // close icon
  //         keyboard: true, // for close on esc key
  //         onOk() {
  //           props.history.push(`/negatives/negative-objects/collection/${id}`);
  //         },
  //         onCancel() {
  //           console.log('Cancel');
  //         },
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     unexpectedError(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const getObjectsData = async (pagination, filters = {}, sorter = '') => {
  //   try {
  //     let checkData = 0;
  //     setLoading(true);
  //     filters['collections'] = props?.tabs_permissions?.negatives?.view ? props.collections_permissions.view : [];
  //     filters['object_type'] = { _eq: 'negative' };
  //     const dataObj = {
  //       fields: ['object_type,id,title,provenance,acquisition,collections.name,collections.id,negative.obj_name,negative.thumbnail'],
  //       filters: filters,
  //       sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
  //       offset: pagination.pageSize * (pagination.current - 1),
  //       limit: pagination.pageSize,
  //       meta: 'filter_count',
  //     };
  //     const response = await props.negativeFilterNew(dataObj);
  //     checkData = response.data.length;
  //     pagination.total = response.meta.filter_count;
  //     setPagination(pagination);
  //     setObjects(response.data);
  //     setLoading(false);

  //     /**Show Popup if collection negative is not created **/
  //     if (section === 'list' && id && !checkData && (!!props.tabs_permissions.negatives?.create || props.roleType == 'admin')) {
  //       Modal.confirm({
  //         icon: <ExclamationCircleOutlined style={{ color: '#1890ff' }} />,
  //         title: 'Information',
  //         content: 'Negative is not created yet',
  //         okText: 'Create now',
  //         cancelText: 'Not now',
  //         centered: true, // show popup at the center of screen
  //         closable: true, // close icon
  //         keyboard: true, // for close on esc key
  //         onOk() {
  //           props.history.push(`/negatives/negative-objects/collection/${id}`);
  //         },
  //         onCancel() {
  //           console.log('Cancel');
  //         },
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     unexpectedError(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // const getObjectsData = async () => {
  //   try {
  //     let checkData = response?.meta?.filter_count ?? 0;
  //     pagination.total = response.meta.filter_count;
  //     setPagination(pagination);
  //     setObjects(response.data);
  //     setLoading(false);

  //     /**Show Popup if collection negative is not created **/
  //     if (section === 'list' && id && !checkData && (!!props.tabs_permissions.negatives?.create || props.roleType == 'admin')) {
  //       Modal.confirm({
  //         icon: <ExclamationCircleOutlined style={{ color: '#1890ff' }} />,
  //         title: 'Information',
  //         content: 'Negative is not created yet',
  //         okText: 'Create now',
  //         cancelText: 'Not now',
  //         centered: true, // show popup at the center of screen
  //         closable: true, // close icon
  //         keyboard: true, // for close on esc key
  //         onOk() {
  //           props.history.push(`/negatives/negative-objects/collection/${id}`);
  //         },
  //         onCancel() {
  //           console.log('Cancel');
  //         },
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     unexpectedError(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const popUp = checkData => {
    if (section === 'list' && id && !checkData && (!!props.tabs_permissions.negatives?.create || props.roleType == 'admin')) {
      Modal.confirm({
        icon: <ExclamationCircleOutlined style={{ color: '#1890ff' }} />,
        title: 'Information',
        content: 'Negative is not created yet',
        okText: 'Create now',
        cancelText: 'Not now',
        centered: true,
        closable: true,
        keyboard: true,
        onOk() {
          props.history.push(`/negatives/negative-objects/collection/${id}`);
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }
  };

  const onFinishFilter = async (values, pagination = intialPaginationState, sorter = null) => {
    try {
      setLoading(true);
      values['collections'] = props?.tabs_permissions?.negatives?.view ? props.collections_permissions.view : [];
      const test = {
        fields: ['object_type,id,title,provenance,acquisition,collections.name,collections.id,negative.obj_name,negative.thumbnail'],
        filters: values,
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      };
      const response = await props.advancedNegativeFilter(test, 'collection_objects');
      let checkData = response?.meta?.filter_count ?? 0;
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setObjects(response.data);
      setLoading(false);
      popUp(checkData);
    } catch (error) {
      console.log(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      width: 90,
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      sorter: true,
      sortOrder: sortedInfo.columnKey === 'title' ? sortedInfo.order : null,
      filteredValue: filteredInfo.title || null,
      ...filter('title'),
      ellipsis: true,
    },
    {
      title: 'Acquisition',
      dataIndex: 'acquisition',
      key: 'acquisition',
      sorter: true,
      sortOrder: sortedInfo.columnKey === 'acquisition' ? sortedInfo.order : null,
      filteredValue: filteredInfo.acquisition || null,
      ...filter('acquisition'),
      ellipsis: true,
    },

    {
      title: 'Negative',
      dataIndex: 'negative.obj_name',
      key: 'negative.obj_name',
      sorter: true,
      sortOrder: sortedInfo.columnKey === 'negative.obj_name' ? sortedInfo.order : null,
      filteredValue: filteredInfo.negative || null,
      ...filter('negative.obj_name'),
      ellipsis: true,
      render: (text, record) => {
        return record?.negative?.obj_name ? record.negative.obj_name : 'Not Created';
      },
    },
    {
      title: 'Thumbnail',
      dataIndex: 'thumbnail',
      key: 'thumbnail',
      align: 'center',
      render: (text, record) =>
        record?.negative?.thumbnail ? (
          <PictureCell dataIndexValue={record.negative.thumbnail} getFile={props.getFile} width={50} />
        ) : (
          <span>-</span>
        ),
    },
    {
      title: 'Actions',
      key: 'action',
      width: 140,
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Tooltip placement="top" title={props.roleType === 'admin' || props?.tabs_permissions?.negatives?.edit ? 'Edit' : 'View'}>
              <button className="edit-btn" onClick={() => negativeObject(record.id, '1')}>
                {props.roleType === 'admin' || props?.tabs_permissions?.negatives?.edit ? <FormOutlined /> : <EyeOutlined />}
              </button>
            </Tooltip>
            <Tooltip placement="top" title="Negative">
              <button className="edit-btn" onClick={() => negativeObject(record.id, '2')}>
                <DatabaseOutlined />
              </button>
            </Tooltip>
            <Tooltip placement="top" title="Image Description">
              <button className="edit-btn" onClick={() => negativeObject(record.id, !!record.negative ? '3' : '2')}>
                <DatabaseOutlined />
              </button>
            </Tooltip>
            {props.deleteRecord(
              props,
              record.id,
              'collection_obj',
              'negative object and its associated records?',
              objects,
              setObjects,
              props?.tabs_permissions?.negatives?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  let negativeObject = (id, tab) => {
    localStorage.setItem('negActive', tab);
    props.history.push('/negatives/negative-objects/edit/' + id);
  };
  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter?.order ? sorter : '');
    setLoading(true);

    const filtersitems = Object.entries(filters).reduce((acc, [key, val]) => {
      if (val) {
        acc[key === 'negative.obj_name' ? 'negative' : key] =
          key === 'negative.obj_name'
            ? { obj_name: { _icontains: val[0] } }
            : key === 'collections'
            ? { name: { _icontains: val[0] } }
            : { _icontains: val[0] };
      }
      return acc;
    }, {});

    setFilteredInfo(filters);
    setSortedInfo(sorter);

    const formValues = formRef?.current?.getFieldsValue();
    await onFinishFilter({ filtersitems, ...formValues }, pagination, sorter);
  };

  const getDataByArtist = async artistID => {
    setFilteredInfo({});
    setSortedInfo({});
    let filtersitems = artistID ? { ...defaultFilter, ...{ creator: { _eq: artistID } } } : defaultFilter;
    await getObjectsData(intialPaginationState, filtersitems);
  };
  const resetFilters = async () => {
    formRef.current.resetFields();
    await onFinishFilter({}, pagination);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Negatives", href: "/negatives/negative-objects" }, { title: "Negative Objects" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                Negative Objects List
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {section === 'list' && id
                ? props.createButton(
                    props.roleType,
                    props.tabs_permissions.negatives,
                    `/negatives/negative-objects/collection/${id}`,
                    ' Create Negative Object'
                  )
                : props.createButton(
                    props.roleType,
                    props.tabs_permissions.negatives,
                    `/negatives/negative-objects/new`,
                    ' Create Negative Object'
                  )}
            </Col>
          </Row>
          <Form
            ref={formRef}
            layout="vertical"
            {...formItemLayout}
            onFinish={onFinishFilter}
            initialValues={{ layout: tailFormItemLayout }}
          >
            <Row gutter={24}>
              <Col xs={24} sm={12} md={4} lg={4}>
                <Form.Item
                  name="keyword"
                  label="Keyword"
                  rules={[
                    {
                      max: 50,
                      message: 'Please enter 50 characters or fewer!',
                    },
                  ]}
                >
                  <Input placeholder="Type... " />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={4} lg={4}>
                <Form.Item
                  name="obj_name"
                  label="Common Title"
                  rules={[
                    {
                      max: 50,
                      message: 'Please enter 50 characters or fewer!',
                    },
                  ]}
                >
                  <Input placeholder="Type..." />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={4} lg={4}>
                <Form.Item name="artist" label="Artist">
                  <Select
                    placeholder="Select Artist/ Creator"
                    optionFilterProp="children"
                    showSearch
                    allowClear
                    filterOption={(input, option) => option.children.includes(input)}
                    // onChange={getDataByArtist}
                  >
                    {artists?.map(artist => {
                      return (
                        <Select.Option key={artist.id} value={artist.id}>
                          {artist.First_Name} {artist.last_name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={12} md={12} lg={12}>
                <Form.Item>
                  <Button className="save-btn" type="primary" style={{ margin: '25px 8px' }} htmlType="submit">
                    Search
                  </Button>
                </Form.Item>
                <Button
                  style={{
                    marginLeft: '10px',
                    height: '42px',
                    marginTop: '28px',
                  }}
                  size="small"
                  danger
                  onClick={resetFilters}
                  icon={<ReloadOutlined />}
                >
                  Reset Filters
                </Button>
              </Col> */}
              <Col xs={24} sm={24} md={8} lg={8}>
                <Form.Item>
                  <Button
                    type="primary"
                    size="small"
                    htmlType="submit"
                    style={{
                      marginTop: '28px',
                      height: '42px',
                    }}
                    icon={<SearchOutlined />}
                  >
                    Search
                  </Button>
                  <Button
                    style={{
                      marginLeft: '10px',
                      height: '42px',
                      marginTop: '28px',
                    }}
                    size="small"
                    danger
                    onClick={resetFilters}
                    icon={<ReloadOutlined />}
                  >
                    Reset Filters
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <hr />
          <div className="users-list">
            {
              <Table
                rowKey="id"
                scroll={{ x: 'max-content' }}
                columns={columns}
                bordered
                dataSource={objects}
                pagination={{ ...pagination, ...showingPageTotalRange }}
                loading={loading}
                onChange={handleTableChange}
              />
            }
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default Objects;
